import React, { useEffect } from 'react';
import classes from './AboutShapes.module.css';
import { Donut } from 'react-awesome-shapes/dist/shapes/donut';
import { Cross } from 'react-awesome-shapes/dist/shapes/cross';
import { CircleGrid } from 'react-awesome-shapes/dist/shapes/circlegrid';
import { SquareDonut } from 'react-awesome-shapes/dist/shapes/squareDonut';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutShapes = () => {
  useEffect(() => {
    AOS.init({
      // once: true,
      duration: 1000
    });
  });

  return (
    <>
      <div data-aos={'fade-up'}>
        <Donut
          data-aos={'fade-up'}
          className={classes.donut}
          color="#423f3d"
          size={['160px', '180px', '200px', '200px']}
          width={['35px', '35px', '60px', '60px']}
          zIndex={0}
          style={{ overflowX: 'hidden' }}
        />
      </div>
      <Cross
        className={classes.cross}
        size={['80px', '100px', '120px', '180px']}
        zIndex={0}
        color="#423f3d"
        style={{ overflowX: 'hidden' }}
      />
      <CircleGrid
        size={['120px', '150px', '180px', '200px']}
        className={classes.circlegrid2}
        color="#10b981aa"
        zIndex={0}
      />
      <SquareDonut
        className={classes.squaredonut2}
        size={['130px', '150px', '200px', '200px']}
        zIndex={0}
        color="#10b98155"
      />
      <Donut
        className={classes.donut3}
        color="#423f3d"
        size={['160px', '180px', '200px', '200px']}
        width={['35px', '35px', '60px', '60px']}
        zIndex={0}
        style={{ overflowX: 'hidden' }}
      />
      <Cross
        className={classes.cross3}
        size={['80px', '100px', '120px', '180px']}
        zIndex={0}
        color="#423f3d"
        style={{ overflowX: 'hidden' }}
      />
      <CircleGrid
        className={classes.circlegrid4}
        color="#10b981aa"
        size={['120px', '150px', '180px', '200px']}
        zIndex={0}
      />
      <SquareDonut
        className={classes.squaredonut4}
        size={['130px', '150px', '200px', '200px']}
        zIndex={0}
        color="#10b98155"
      />
    </>
  );
};

export default AboutShapes;
